import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import { Values } from '../../../../values/Values';
import Grid from '@material-ui/core/Grid';
import clsx from 'clsx';
import Chart from 'react-apexcharts';
import theme from '../../../../theme';
import CardHeader from '@material-ui/core/CardHeader';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import moment from 'moment';


const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
    color: Values.cores.cinza
  },
  gridTabela: {
    margin: 20
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

function DialogAnaliseEstatistica(props) {
  const classes = useStyles();
  const {
    open,
    setOpen,
    informacoes
  } = props;

  const handleClose = () => {
    setOpen(false);
  };

  function getLabelsGraficoMovimentacoes(movimentacaoInsumo) {
    let labels = [];
    movimentacaoInsumo.movimentacoes.map(movimentacao => {
      labels.push(moment(movimentacao.createdAt).format('DD/MM/YYYY'))
    });
    return labels;
  }

  function getValoresGraficoMovimentacoes(movimentacaoInsumo) {
    let valores = [];
    movimentacaoInsumo.movimentacoes.map(movimentacao => {
      valores.push(movimentacao.quantidade);
    });
    return valores;
  }

  function getValoresGraficoQuantidades(movimentacaoInsumo) {
    return [movimentacaoInsumo.quantidadeUtilizada, movimentacaoInsumo.quantidadeRestante]
  }



  return (
    <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
      <AppBar className={classes.appBar}>
        <Toolbar>
          <Typography variant="h6" className={classes.title} >ANÁLISE ESTATÍSTICA POR INSUMO</Typography>
          <IconButton edge="end" color="inherit" onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          md={12}
          xs={12}
          className={clsx({
            [classes.gridTabela]: true
          })}
        >
          {
            informacoes && informacoes.result &&
            informacoes.result.map((movimentacaoInsumo) => {
               return <Card
                style={{
                  borderRadius: 15,
                  marginBottom: 20,
                }}
                elevation={3}
               >
                 <CardHeader
                   title={`Análise estatística insumo: ${movimentacaoInsumo.estoqueInsumo.insumo.descricao}`}
                 />
                 <CardContent>

                   <Grid
                     container
                     spacing={2}
                   >
                     <Grid
                       item
                       md={6}
                       xs={12}
                     >
                       <Card
                         style={{
                           borderRadius: 15,
                         }}
                       >
                         <CardHeader
                           title={`Gráfico por movimentação`}
                         />
                         <CardContent>
                           <Chart
                             options={{
                               chart: {
                                 id: 'graficoAnaliseEstatisticaMovimentacoesInsumos',
                                 type: 'bar',
                                 height: 350,
                                 toolbar: {
                                   show: false
                                 },
                               },
                               plotOptions: {
                                 bar: {
                                   colors: {
                                     ranges: [{
                                       from: 0,
                                       to: 100000000,
                                       color: theme.palette.primary.main
                                     }, {
                                       from: -100000000,
                                       to: 0,
                                       color: theme.palette.error.main
                                     }]
                                   },
                                   columnWidth: '65%',
                                 }
                               },
                               dataLabels: {
                                 enabled: false
                               },
                               markers: {
                                 size: 6,
                               },
                               fill: {
                                 colors: [theme.palette.info.main]
                               },
                               yaxis: {
                                 labels: {
                                   formatter: function (val) {
                                     return val;
                                   },
                                 },
                                 title: {
                                   text: 'Quantidade'
                                 },
                               },
                               xaxis: {
                                 type: 'category',
                                 categories: getLabelsGraficoMovimentacoes(movimentacaoInsumo),
                               },
                               tooltip: {
                                 shared: true,
                                 y: {
                                   show: true,
                                   formatter: function (val) {
                                     return val
                                   }
                                 },
                                 x: {
                                   show: true,
                                   formatter: function(val) {
                                     return val
                                   }
                                 }
                               },

                             }}
                             type={'bar'}
                             series={[{
                               name: 'Quantidade',
                               data: getValoresGraficoMovimentacoes(movimentacaoInsumo)
                             }]}
                             height={350}
                           />
                         </CardContent>
                       </Card>
                     </Grid>
                     <Grid
                       item
                       md={6}
                       xs={12}
                     >
                       <Card
                         style={{
                           borderRadius: 15,
                         }}
                       >
                         <CardHeader
                           title={`Gráfico por movimentação`}
                         />
                         <CardContent>
                           <Chart
                             options={{
                               chart: {
                                 height: 280,
                                 type: 'pie',
                               },
                               dataLabels: {
                                 enabled: true
                               },
                               responsive: [{
                                 options: {
                                   legend: {
                                     show: true
                                   }
                                 }
                               }],

                               legend: {
                                 position: 'top',
                               },
                               labels: ['Quantidade utilizada', 'Quantidade restante'],
                               colors: [theme.palette.error.main, theme.palette.primary.main]
                             }}
                             type={'pie'}
                             series={getValoresGraficoQuantidades(movimentacaoInsumo)}
                             height={280}
                           />
                         </CardContent>
                       </Card>
                     </Grid>
                   </Grid>

                 </CardContent>
               </Card>
            })
          }
        </Grid>
      </Grid>
    </Dialog>
  );
}

export default DialogAnaliseEstatistica;
